module.exports = __webpack_public_path__ + "img/little_robot.907c6c46.png";